import { TableCell } from "~/shadcn/ui/table"
import { useCastingCall } from "./CastingCallRow"

export const CampaignNameCell = () => {
  const { castingCall } = useCastingCall()

  return <TableCell>{castingCall.campaignName}</TableCell>
}
